import { render, staticRenderFns } from "./SoftwerDevelopment.vue?vue&type=template&id=7d7facf5&"
import script from "./SoftwerDevelopment.vue?vue&type=script&lang=js&"
export * from "./SoftwerDevelopment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports